/* global Modernizr */
/* global Browser */
import {getClosestByClass} from '../lib/helper';
import {currentBreakpoint} from '../lib/responsive';
import {breakpoints} from '../config/responsive';
import Swiper from '../custom/swiper';
import {throttle} from 'lodash';
import LazyLoadingImage from './LazyLoadingImage';
import AddTo from './AddTo';

/**
 *
 * @type {Class}
 */
export default class OverflowingSwiper {

  constructor(el) {

    this.el = el;
    this.swiperContainer = this.el.querySelector('.tc-overflowing-swiper');
    this.initialSlides = this.swiperContainer.querySelectorAll('.swiper-slide');
    this.initialSlidesLength = this.initialSlides.length;
    this.overflowingSwiperPrevTrigger = this.el.querySelector('.swiper-button-prev');
    this.overflowingSwiperNextTrigger = this.el.querySelector('.swiper-button-next');
    this.swiperBreakpoints = {};
    this.defaultSlidesPerView = 1;
    this.swiperOptions = {
      //loop: false,
      freeMode: false,
      // freeModeSticky: true,
      // freeModeMomentum: true,
      // freeModeMinimumVelocity: 0.02,
      // freeModeMomentumRatio: 0.5,
      loopedSlides: 12,
      spaceBetween: 0,
      centeredSlides: false,
      paginationClickable: false,
      grabCursor: false,
      threshold: 20,
      simulateTouch: true,
      slidesPerView: 'auto',
      effect: 'slide',
      onInit: swiper => {

        this.checkSwiperForLoop(swiper);
      }
    };

    // get element with necessary event
    this.parentTabSwipeableModule = getClosestByClass(this.el, 'tc-tabs-swipeable');
    this.isStageStarSwiper = !!getClosestByClass(this.el, 'stage-star-main');
    // debugger;
    // only init swiper on non-touch devices - #12174
    if (!(Modernizr && Modernizr.touchevents && (Browser.device.type === 'tablet' || Browser.device.type === 'mobile'))) {

      this.initSwiper();
    } else {
      if (this.overflowingSwiperPrevTrigger) {
        this.overflowingSwiperPrevTrigger.style.display = 'none';
      }
      if (this.overflowingSwiperNextTrigger) {
        this.overflowingSwiperNextTrigger.style.display = 'none';
      }
    }

    this.registerEvents();

    /**
     * Redmine #19262
     * @suchnice
     */
    if (this.el.classList.contains('stage-stars-slider')) {

      const hack = setInterval(() => {

        const slidesFit = this.initialSlidesFitInView();
        if (!slidesFit && !this.needSlidesInViewCheck && (currentBreakpoint !== 's' && currentBreakpoint != 'xs')) {

          this.checkSwiperForLoop(this.swiper);
          clearInterval(hack);
        }
      }, 120);

      setTimeout(() => {
        clearInterval(hack);
      }, 10000);
    }
  }

  registerEvents() {

    // Redmine #12703
    /* fixed with swiper v3.4.2+
    if (Browser.os.name === 'Windows' && Browser.browserName === 'Chrome') {
      // console.log('[info] Chrome on Win click helper');
      let linkHelper = this.el.querySelectorAll('a[href]');

      map(linkHelper, link => {

        if (link.getAttribute('href') !== '#') {

          link.addEventListener('click', e => {
            window.location.href = e.currentTarget.href;
          });
        }
      });
    } */


    if (!(Modernizr && Modernizr.touchevents)) {

      if (this.parentTabSwipeableModule) {

        this.parentTabSwipeableModule.addEventListener('tabChange', this.onTabChangeUpdate.bind(this), false);
      }

      window.addEventListener('resize', throttle(this.checkSwiperForLoop.bind(this, this.swiper), 250), false);
    }
  }

  initSwiper() {

    // slides in view doesn't work in ie9 due to width-calculation for swiper-wrapper and precentage width of swiper-slides
    if (Browser.browser.major === '9' && Browser.isIE) {

      if (!this.isStageStarSwiper) {

        // get the first slides classes to set slidesPerView property
        const swiperSlideClasses = [].slice.call(this.swiperContainer.querySelector('.swiper-slide').classList);
        const swiperSlideGridClasses = swiperSlideClasses
          .reduce((prev, className) => {

            let grid = [];
            let breakpoint = '';
            let gridWidth = '';

            // check class for grid-definition
            if (className.search(/gr-/g) >= 0) {

              //filter specfic breakpoint
              if (className.search(/@.+/g) >= 0) {

                grid = className.split('@');
                breakpoint = grid[1];
                gridWidth = grid[0].replace('gr-', '');

                // set global breakpoint
              } else {

                gridWidth = className.replace('gr-', '');
                breakpoint = 'global';
              }

              prev[breakpoint] = gridWidth;
            }

            return prev;
          }, {});

        for (let i = 0; i < breakpoints.length; i++) {

          let breakpoint = breakpoints[i].identifier;
          let breakpointMax = breakpoints[i].max;

          if (breakpointMax) {

            this.swiperBreakpoints[breakpointMax] = {};

            if (breakpoint in swiperSlideGridClasses) {

              this.swiperBreakpoints[breakpointMax].slidesPerView = 12 / parseInt(swiperSlideGridClasses[breakpoint], 10);
            } else if (swiperSlideGridClasses.global) {

              this.swiperBreakpoints[breakpointMax].slidesPerView = 12 / parseInt(swiperSlideGridClasses.global, 10);
            } else {

              this.swiperBreakpoints[breakpointMax].slidesPerView = 1;
            }
          } else {

            if (breakpoint in swiperSlideGridClasses) {

              this.defaultSlidesPerView = (12 / parseInt(swiperSlideGridClasses[breakpoint], 10));
            } else if (swiperSlideGridClasses.global) {

              this.defaultSlidesPerView = (12 / parseInt(swiperSlideGridClasses.global, 10));
            } else {

              this.defaultSlidesPerView = 1;
            }
          }
        }

        this.swiperOptions.breakpoints = this.swiperBreakpoints;
        this.swiperOptions.slidesPerView = this.defaultSlidesPerView;
      } else {

        this.swiperOptions = {
          loop: false,
          freeMode: false,
          // freeModeMomentum: true,
          // freeModeMinimumVelocity: 0.02,
          // freeModeMomentumRatio: 0.5,
          spaceBetween: 20,
          centeredSlides: false,
          paginationClickable: false,
          grabCursor: false,
          // threshold: 20,
          simulateTouch: true,
          slidesPerView: 'auto',
          effect: 'slide'
        };

        this.swiperOptions.breakpoints = {
          480: {
            slidesPerView: 1
          },
          797: {
            slidesPerView: 2
          },
          989: {
            slidesPerView: 2
          },
          1169: {
            slidesPerView: 2
          },
          1469: {
            slidesPerView: 2
          }
        };

        this.swiperOptions.slidesPerView = 3;
      }
    }

    if (this.overflowingSwiperPrevTrigger && this.overflowingSwiperNextTrigger) {

      this.swiperOptions.nextButton = this.overflowingSwiperNextTrigger;
      this.swiperOptions.prevButton = this.overflowingSwiperPrevTrigger;
    }

    this.swiper = new Swiper(this.swiperContainer, this.swiperOptions);
  }

  // fireRefreshEventOnWindow() {
  //
  //   var evt = document.createEvent('HTMLEvents');
  //   evt.initEvent('resize', true, false);
  //   window.dispatchEvent(evt);
  //
  //   return false;
  // }

  checkSwiperForLoop(swiper) {

    /**
     * NOTE: this was here bc of swiper acting weird when it was the exact width of 12 grids
     */

    // caused crashes on IE11 & Edge, so better don't do it!
    // if (!(Browser.browser.major === '11' && Browser.isIE) && !Browser.isEdge) {
    //
    //   this.fireRefreshEventOnWindow();
    // }


    if (Browser.browser.major === '9' && Browser.isIE) {

      return;
    }

    const slidesFit = this.initialSlidesFitInView();

    if (slidesFit && this.needSlidesInViewCheck) {

      this.needSlidesInViewCheck = false;
      swiper.params.loop = false;
      const slidesToRemove = [];

      for (let i = 0; i < swiper.slides.length; i++) {

        if (swiper.slides[i].classList.contains('swiper-slide-duplicate')) {

          slidesToRemove.push(i);
        }
      }
      swiper.removeSlide(slidesToRemove);
      swiper.destroy(false, true);
      swiper.init();
    } else if (!slidesFit && !this.needSlidesInViewCheck && (currentBreakpoint !== 's' && currentBreakpoint != 'xs')) {
      try {
        this.needSlidesInViewCheck = true;
        swiper.params = swiper.params || {};
        swiper.params.loop = true;
        swiper.destroy(false, true);
        swiper.init();
        this.needSlidesInViewCheck = true;

        // reinit lazyload-module to get the cloned slides
        window.taikoComponent.reloadModule(LazyLoadingImage, '.tc-lazy-loading-image');
        window.taikoComponent.reloadModule(AddTo, '.tc-add-to');
      } catch (e) {
        // noop
      }
    }
  }

  initialSlidesFitInView() {

    let width = 0;
    const maxWidth = this.swiperContainer.offsetWidth + 80;

    for (let i = 0; i < this.initialSlidesLength; i++) {

      width += this.initialSlides[i].offsetWidth;
    }

    if (maxWidth >= width) {

      return true;
    } else {

      return false;
    }
  }

  onTabChangeUpdate() {
    const tabWrapper = getClosestByClass(this.el, 'tab-wrapper');

    if (tabWrapper && tabWrapper.classList.contains('active')) {

      this.swiper.update();
    }
  }
}
